import React from 'react';
import PropTypes from 'prop-types';
import Loader from './Loader';
import { spinnerSizes } from '../common/constants';

function LoaderOverlay(props) {
  const { id, opacity, style, display, backGroundStyles, foregroundStyles } = props;
  const getBackgroundStyles = () => ({
    display: 'block',
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    backgroundColor: `rgba(255, 255, 255, ${opacity})`,
    zIndex: 1021,
  });
  const getForegroundStyles = () => ({
    display: 'table',
    width: '100%',
    height: '100%',
    textAlign: 'center',
  });

  const bgStyle = {
    ...(backGroundStyles || {}),
    ...(getBackgroundStyles() || {}),
  };

  const fgStyle = {
    ...(foregroundStyles || {}),
    ...(getForegroundStyles() || {}),
  };

  const loaderStyle = { ...style };
  const renderOverlayLoader = () => {
    if (display) {
      return (
        <div className="sh_loader" id={id} style={loaderStyle} data-testid="sh-overlay-loader">
          <div className="sh_loader__background" style={bgStyle} data-testid="sh-overlay-loader-background">
            <div
              className="sh_loader__background__foreground"
              style={fgStyle}
              data-testid="sh-overlay-loader-foreground"
            >
              <div className="sh_loader__background__foreground__message" data-testid="sh-overlay-loader-message">
                <Loader spinnerSize={spinnerSizes.X_LARGE} />
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  return renderOverlayLoader();
}

/* eslint-disable react/forbid-prop-types */
LoaderOverlay.propTypes = {
  display: PropTypes.bool,
  id: PropTypes.string,
  style: PropTypes.object,
  backGroundStyles: PropTypes.object,
  foregroundStyles: PropTypes.object,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  opacity: PropTypes.number,
};

LoaderOverlay.defaultProps = {
  display: false,
  opacity: 0.9,
  size: 'lg',
};

export default LoaderOverlay;
